import React, { useEffect, useState } from "react";
import Navbar from "../components/Navbar";
import Fotter from "../components/Fotter";
import { BASE_URL } from "./Config";
import axios from "axios";
import { Link } from "react-router-dom";

export default function TermsConditions() {
  const [terms_conditions, setTerms_Condition] = useState("");

  useEffect(() => {
    axios
      .get(`${BASE_URL}/get_terms_conditions.php?t=${Date.now()}`)
      .then((res) => {
        console.log(res);
        if (res.data.success) {
          setTerms_Condition(res.data[0]);
          // console.log(res.data.content);
        } else {
          console.error("API response error:", res.data.message);
        }
      })
      .catch((err) => console.error("API request failed:", err));
  }, []);

  return (
    <>
      <Navbar />

      <div className="page-info">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="info">
                <Link to="/">
                  <p>HOME</p>
                </Link>
                <span> /</span>
                <Link to="/">
                  <p>FASTTRADE</p>
                </Link>
                <span> /</span>
                <p>Terms & Conditions</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="page-settings">
        <div className="container">
          <div
            className="row"
            dangerouslySetInnerHTML={{
              __html: String(terms_conditions.content),
            }}
          ></div>
        </div>
      </div>

      <Fotter />
    </>
  );
}
